import React from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import "./education.css";

const Education = ({ nextStep, prevStep }) => {
  return (
    <Box className='education-container'>
      <Box className='left-flower-character'>
        <img src='./CYPImages/WormisFlower.png' alt='left-flower character' className='left-flower-character-image' />
      </Box>
      <Box className='education-form-container'>
        {/* Title */}

        <Typography variant='h4' className='education-title' align='center' gutterBottom>
          Education
        </Typography>

        {/* Subtitle */}
        <Typography variant='body1' className='education-subtitle'>
          We will always make it a priority for you to get a school place as <br /> soon as possible. While waiting, the
          staff at Little Norway will <br />
          continue to support you to build and develop your interest.
        </Typography>
        <Box className='girl-box'>
          <img src='./CYPImages/girldrawingpicture.png' alt='Bottom Character' className='girl-image' />
        </Box>
        {/* Speech bubbles */}
        <Box className='speech-bubbles'>
          <Box className='bubble yellow-bubble'>
            During term time you will be expected to follow a school routine until you get a school place.
          </Box>
          <Box className='bubble red-bubble' ml={10}>
            The TV, Xbox, and any non-educational <br />
            entertainment is not available during school <br />
            time.
          </Box>
          <Box className='bubble green-bubble'>Staff will arrange educational activities between 9am - 3pm.</Box>
          <Box className='bubble purple-bubble' ml={10}>
            The WIFI will be turned off during school <br />
            hours.
          </Box>
          <Box className='bubble blue-bubble'>There is no free time during school hours.</Box>
        </Box>
        <Grid container justifyContent='space-between' alignItems='center' mt={2}>
          <Grid item>
            <Button type='button' variant='contained' color='primary' onClick={prevStep}>
              Previous
            </Button>
          </Grid>
          <Grid item>
            <Button type='button' variant='contained' color='primary' onClick={nextStep}>
              Next
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Box className='bottom-education' mr={3}>
        <img src='./CYPImages/WormisStayingHome.png' alt='Bottom Character' className='bottom-education-image' />
      </Box>
    </Box>
  );
};

export default Education;
